import { PimStoreWrapper } from "../v1-adapters/pim-store-wrapper.js";
import { RdfsFileAdapter } from "@dataspecer/rdfs-adapter";
class IdentityIriProvider {
    cimToPim = (cimIri) => cimIri;
    pimToCim = (pimIri) => pimIri;
}
export async function createRdfsModel(urls, httpFetch, label) {
    const cim = new RdfsFileAdapter(urls, httpFetch);
    cim.setIriProvider(new IdentityIriProvider());
    const cimObject = await cim.getCim();
    const resources = cimObject.entities;
    const storeWrapper = new PimStoreWrapper({ resources }, undefined, undefined, urls, label);
    storeWrapper.fetchFromPimStore();
    return storeWrapper;
}
//# sourceMappingURL=rdfs-model.js.map